import axios from "axios";

const shopURL = `${process.env.VUE_APP_APIURL}/api/app/shop`;

const shopClient = axios.create({
  baseURL: shopURL
});

const requestShopList = parameter => {
  return shopClient.get(
    `/shop-page?EcodeId=${parameter.EcodeId}&ShopCategoryId=${parameter.ShopCategoryId}`
  );
};

const requestShopDetail = parameter => {
  return shopClient.get(
    `/shop-detail?shopId=${parameter.id}&EcodeId=${parameter.EcodeId}`
  );
};

const requestObituaryShopInfo = encodedId => {
  return shopClient.get(`/shop-obituary-info?EcodeId=${encodedId}`);
};

// const requestShopPayParamRegist = parameter => {
//   return shopClient.post(`/shop-pay-param/regist`, parameter);
// };

const requestShopPayParamRegist = parameter => {
  const formData = new FormData();

  if(parameter.photo) {
    formData.append("fileList", parameter.photo);
  }
  formData.append("orderInfo", JSON.stringify(parameter));
  
  return shopClient.post(`/shop-pay-param/regist`, formData);
};

const requestGetShopOrderInfo = async params => {
  return shopClient.get(
    `/order/info?merchant_uid=${params.merchant_uid}&imp_uid=${params.imp_uid}`
  );
};

const requestConfirmToss = async params => {
  return shopClient.post(
    `/order/confirm-toss?amount=${params.amount}&orderId=${params.orderId}&paymentKey=${params.paymentKey}`
  );
};

const requestTossHook = async params => {
  return shopClient.post(
    `/order/toss-webhook`
  );
};

export {
  requestShopList,
  requestShopDetail,
  requestObituaryShopInfo,
  requestShopPayParamRegist,
  requestGetShopOrderInfo,
  requestConfirmToss,
  requestTossHook,
};
